<div [class]="containerClass()" aria-hidden="true">
  <svg
    [style]="iconStyle()"
    [class]="svgClass()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        d="M12,21A9,9,0,1,1,18.18,5.45a.75.75,0,0,1,0,1.06.74.74,0,0,1-1.06,0A7.51,7.51,0,1,0,19.5,12,.75.75,0,0,1,21,12,9,9,0,0,1,12,21Z"
      />
    </g>
  </svg>
</div>
